import {Injectable} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {UntypedFormBuilder, UntypedFormGroup, Validators} from '@angular/forms';
import {ValidationService} from '@common_libraries/Services/validation/validation.service';
import {LocalStorageService} from 'ngx-webstorage';
import {UserService} from '@services/user/user.service';
import {SessionService} from '@services/session/session.service';
import {debounceTime} from 'rxjs/operators';

@Injectable()
export class VerifypasswordresetComponentModel {

  haveCode = false;
  pageMsg = '';
  pwdResetForm: UntypedFormGroup;
  code = '';
  errorsList: Array<ResetErrors>;
  formValid = false;
  obSubs: any = [];

  constructor( private fb: UntypedFormBuilder,
               private  router: Router,
               private localSt: LocalStorageService,
               private sessionService: SessionService,
               private userService: UserService) {
    this.pwdResetForm = this.fb.group({});

    this.localSt.clear('companyid');
    this.localSt.clear('isloggedin');
    this.localSt.clear('moduleauthdata');
    this.sessionService.SetIsLoggedIn(false);
    this.errorsList = [];
  }



  public initModel(route: ActivatedRoute) {
    this.obSubs.push(route.params.subscribe(param => {
      // get the query string code value
      this.validateCode(param.Guid);
    }));
  }

  public destroyModel() {
    this.obSubs.forEach((sub) => {
      sub.unsubscribe();
    });
  }

  private validateCode(code: string) {
    this.code = code;

    if (code === undefined) {
      this.haveCode = false;
      this.pageMsg = 'Reset code not found.';
    } else {

      this.userService.ValidateResetPasswordCode(code).subscribe((res: PwdResetReturn) => {
        if (res.success) {
          this.createForm();
          this.haveCode = true;
        } else {
          this.haveCode = false;
          this.pageMsg = res.msg;
        }
      });
    }
  }

  public createForm() {
    // // create form
    this.pwdResetForm = this.fb.group({
      pwd: ['', [Validators.required, ValidationService.passwordValidator]],
      confirmPwd: ['', [Validators.required]],
    });

    this.pwdResetForm.get('pwd')
      .valueChanges
      .pipe(debounceTime(500))
      .subscribe(data => {
        this.pwdResetForm.get('pwd').markAsDirty();
        this.validateForm('pwd');
      });

    this.pwdResetForm.get('confirmPwd')
      .valueChanges
      .pipe(debounceTime(500))
      .subscribe(data => {
        this.pwdResetForm.get('confirmPwd').markAsDirty();
        this.validateForm('confirmPwd');
      });

  }

  public validateForm(control: string) {
    const pwd = this.pwdResetForm.get('pwd');
    const confirmPwd = this.pwdResetForm.get('confirmPwd');
    let isValid = true;
    if ( control === 'pwd' && pwd.value === '') {
      isValid = false;
      if (this.errorsList.filter( x => x.Name === 'pwd').length === 0) {
        this.errorsList.push(new ResetErrors('pwd', 'Password is required'))
      }
    }else {
      this.errorsList = this.errorsList.filter( x => x.Name !== 'pwd');
    }

    if ( control === 'confirmPwd' && confirmPwd.value === '' ) {
      isValid = false;
      if (this.errorsList.filter( x => x.Name === 'confirmPwd').length === 0) {
        this.errorsList.push(new ResetErrors('confirmPwd', 'Confirm Password is required'))
      }
    }else {
      this.errorsList = this.errorsList.filter( x => x.Name !== 'confirmPwd');
    }

    if (pwd.value !== '' && confirmPwd.value !== '' && pwd.value !== confirmPwd.value) {
      isValid = false;
      if (this.errorsList.filter( x => x.Name === 'confirm').length === 0) {
        this.errorsList.push(new ResetErrors('confirm', 'Password and Confirm Password must match.'))
      }
    }    else {
      this.errorsList = this.errorsList.filter( x => x.Name !== 'confirm');
    }

    // check the pwd form control item
    const pwdErrors = this.pwdResetForm.get('pwd').errors;
    if (pwdErrors !== null && pwdErrors.invalidPassword !== undefined) {
      const msg = ValidationService.getValidatorErrorMessage('invalidPassword');
      const find = this.errorsList.filter( x => x.Name === 'invalidPassword');
      if (find.length === 0) {
        this.errorsList.push(new ResetErrors('invalidPassword', msg));
      }
      isValid = false;
    } else {
      this.errorsList = this.errorsList.filter( x => x.Name !== 'invalidPassword');
    }

    if (!this.pwdResetForm.valid || !isValid) {
      isValid = false;
    }else {
      this.errorsList = [];
    }

    this.formValid = isValid;
}



  public submitReset() {
    const pwd = this.pwdResetForm.get('pwd').value;

    this.userService.VerifyResetPassword(this.code, pwd).subscribe((res: PwdResetReturn) => {
      const myRouter = this.router;
      if (res.success) {
        this.pageMsg = res.msg;
        setTimeout(function(){
          myRouter.navigate(['login/']);
        }, 2000);
      }else {
        this.pageMsg = res.msg;

        if (res.msg.includes('redirected')) {
          setTimeout(function () {
            myRouter.navigate(['login/4']);
          }, 2000);
        }
      }
    });


  }
}

export class ResetErrors {

  Name: string;
  Msg: string;

  constructor(_name: string, _msg: string) {
    this.Name = _name;
    this.Msg = _msg;
  }
}

export class PwdResetReturn {
  success: boolean;
  msg: string;
}
